import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '../Icon';
import { Submenu } from '../Submenu';
import { AccordionProps, SingleAccordionProps } from './Accordion.types';

let count = 0; // Maintain a global count to avoid id collissions

const AccordionTab = ({
  headerText,
  children,
  initialOpen,
}: SingleAccordionProps): JSX.Element => {
  const [active, setActive] = useState(!!initialOpen);
  const [index, setIndex] = useState(count);
  const inputElement = useRef(null);

  useEffect(() => {
    setIndex(count);
    count = count + 1;
  }, []);

  const onClick = () => {
    if (active) {
      setActive(false);
    } else {
      setActive(true);
      inputElement.current.focus();
    }
  };

  return (
    <div className={clsx('accordion__tab', active && 'is-open')}>
      {/* Header Trigger */}
      <input
        id={`item-${index}-control`}
        aria-labelledby={`item-${index}-label`}
        aria-controls={`content-${index}`}
        aria-checked={active}
        className='accordion__tab_checkbox'
        type='checkbox'
        checked={active}
        onChange={onClick}
        ref={inputElement}
      />
      {/* Header */}
      <label
        data-testid={`item-${index}-label`}
        className='accordion__tab_label text-heading_4'
        htmlFor={`item-${index}-control`}
        id={`item-${index}-label`}
      >
        {headerText}
        <Icon
          icon='More48'
          size='xxlarge'
          color='blue'
          className='accordion__tab_label__icon'
        />
      </label>
      {/* Content */}
      <div
        // Without aria-hidden, this div is read as "new line" or "blank" by screen reader
        aria-hidden={!active}
        className='accordion__tab_content'
        id={`content-${index}`}
      >
        {children}
      </div>
      {/* Divider */}
      {/* Without aria-hidden, this div is read as "new line" or "blank" by screen reader */}
      <div className='accordion__divider divider' aria-hidden={true} />
    </div>
  );
};

export const Accordion = ({
  contents,
  submenu,
}: AccordionProps): JSX.Element => {
  return submenu ? (
    <div className='faq__wrapper'>
      <Submenu {...submenu} submenuClassNames='submenu' />
      <div
        className='accordion'
        data-toggle='accordion'
        aria-label='Accordion Control Group Buttons'
      >
        <div className='accordion__tabs'>
          {contents?.map(({ headerText, children, initialOpen }, index) => {
            return (
              <AccordionTab
                key={index}
                headerText={headerText}
                initialOpen={initialOpen}
              >
                {children}
              </AccordionTab>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <div
      className='accordion'
      data-toggle='accordion'
      aria-label='Accordion Control Group Buttons'
    >
      <div className='accordion__tabs'>
        {contents?.map(({ headerText, children, initialOpen }, index) => {
          return (
            <AccordionTab
              key={index}
              headerText={headerText}
              initialOpen={initialOpen}
            >
              {children}
            </AccordionTab>
          );
        })}
      </div>
    </div>
  );
};
